export default "__VITE_ASSET__CrZvY67W__"